import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { ROUTES } from '@/routes/routes';
import { TenantTemplateLibrary } from './communication/TenantTemplateLibrary';

/**
 * Settings → Communication → Templates.
 *
 * Phase 12.5C replaced this page's implementation. It previously read
 * `GET /email-templates`, which returns only *materialized* tenant rows — so a
 * workspace that had never customized anything saw "No templates found" while
 * every platform template was in fact live for it (D-030 read-through). It now
 * renders `<TenantTemplateLibrary>`, which reads `GET /email-template-library`.
 *
 * The legacy `/email-templates` API is deliberately NOT retired; it simply no
 * longer backs this screen.
 */
export function CommunicationTemplatesPage() {
  return (
    <div className="space-y-5">
      <div>
        <Link
          to={ROUTES.SETTINGS_COMMUNICATION}
          className="inline-flex items-center gap-1.5 text-xs text-muted-foreground transition-colors hover:text-foreground"
        >
          <FontAwesomeIcon icon={faChevronLeft} className="h-3 w-3" />
          Communication
        </Link>
        <h1 className="mt-1 text-xl font-semibold text-foreground">Communication Templates</h1>
        <p className="mt-0.5 text-sm text-muted-foreground">
          These email templates are maintained by your service provider. You can customise any of
          them for your workspace, or disable the ones you do not want sent.
        </p>
      </div>

      <TenantTemplateLibrary />
    </div>
  );
}
